import React from "react";
import {
  Box,
  Grid,
  Typography,
  Input,
  TextField,
  Slider,
  InputAdornment,
} from "investira.react.components";

function SliderWithInput(props) {
  const { label, defaultValue, InputProps = {}, onChange } = props;

  const [value, setValue] = React.useState(defaultValue || 0);

  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
    onChange && onChange(event);
  };

  const handleInputChange = (event) => {
    setValue(event.target.value === "" ? 0 : Number(event.target.value));
    onChange && onChange(event);
  };

  const handleBlur = () => {
    if (value < 0) {
      setValue(0);
    } else if (value > 100) {
      setValue(100);
    }
  };

  return (
    <Box>
      <Typography
        id="input-slider"
        variant="caption"
        color="textSecondary"
        gutterBottom
      >
        {label}
      </Typography>
      <Grid container spacing={2} sx={{ alignItems: "center" }}>
        <Grid item>
          <TextField
            value={value}
            size="small"
            onChange={handleInputChange}
            onBlur={handleBlur}
            inputProps={{
              step: 1,
              min: 0,
              max: 100,
              type: "number",
              "aria-labelledby": "input-slider",
            }}
            sx={{
              width: "90px",
            }}
            variant="outlined"
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
              ...InputProps,
            }}
          />
          {/* <Input
            value={value}
            size="small"
            onChange={handleInputChange}
            onBlur={handleBlur}
            inputProps={{
              step: 1,
              min: 0,
              max: 100,
              type: "number",
              "aria-labelledby": "input-slider",
            }}
            sx={{
              width: "100px",
            }}
          /> */}
        </Grid>
        <Grid item xs>
          <Slider
            value={typeof value === "number" ? value : 0}
            onChange={handleSliderChange}
            aria-labelledby="input-slider"
            fullWidth
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default SliderWithInput;
